import React, { Component } from "react";
import "./HabitScorecard.css";

class Wizard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currStage: 0
    };
  }

  nextStage = () => {
    this.setState(prevState => ({
      currStage: prevState.currStage + 1
    }));
  };

  completeWizard = () => {
    this.props.wizardComplete();
  };

  renderStage = () => {
    let stage = this.state.currStage;
    if (stage == 0) {
      return (
        <React.Fragment>
          <div class="card-body">
            <h5 class="card-title">
              What is a <br /> Habit Scorecard?
            </h5>

            <p class="card-text">
              Many of our failures in performance are largely attributable to a
              lack in self-awareness.
            </p>
            <p class="card-text">
              A Habit Scorecard is a tool to help make you more aware of your
              habits and the impact they are having on your life.
            </p>
          </div>
          <div class="card-footer text-right">
            <a href="#" onClick={this.completeWizard} class="card-link">
              Skip Wizard
            </a>
            <a href="#" onClick={this.nextStage} class="card-link">
              Next
            </a>
          </div>
        </React.Fragment>
      );
    }
    if (stage == 1) {
      return (
        <React.Fragment>
          <img
            src="https://imgur.com/vvMaA19.png"
            class="card-img-top"
            alt="..."
          />
          <div class="card-body">
            <h5 class="card-title">How To Use It?</h5>
            <p class="card-text">
              Although an extremely effective tool the Habit Scorecard is also
              simple to use.
            </p>
            <p class="card-text">1. Add your habits to the list.</p>
          </div>

          <div class="card-footer text-right">
            <a href="#" onClick={this.nextStage} class="card-link">
              Next
            </a>
          </div>
        </React.Fragment>
      );
    }
    if (stage == 2) {
      return (
        <React.Fragment>
          <img
            src="https://imgur.com/4OjyWtu.png"
            class="card-img-top"
            alt="..."
          />
          <div class="card-body">
            <h5 class="card-title">How To Use It?</h5>

            <p class="card-text">
              2. Use the buttons to classify them as positive, neutral or
              negative.
            </p>
            <p class="card-text">
              {" "}
              If you're struggling to decide try to determine if the habit is
              helping you in the pursuit of your long term goals.{" "}
            </p>
          </div>

          <div class="card-footer text-right">
            <a href="#" onClick={this.completeWizard} class="card-link">
              Finish
            </a>
          </div>
        </React.Fragment>
      );
    }
  };

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-lg-4" />
          <div className="col-sm-12 col-lg-4">
            <div className="card cardCustom text-white bg-dark">
              {this.renderStage()}
            </div>
          </div>
          <div className="col-sm-12 col-lg-4" />
        </div>
      </div>
    );
  }
}

export default Wizard;
